export enum FulfillmentPackageSplitType {
  BY_COUNT = 'BY_COUNT',
  BY_WEIGHT = 'BY_WEIGHT'
}
